import { DatePicker, IDatePicker, LayerHost, Stack, getId } from "@fluentui/react";
import classNames from "classnames";
import dayjs from "dayjs";
import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setStartOfWeek } from "../reducers/diningReducer";
import { cafeSelector, stationSelector, weekStartSelector } from "../selectors/diningSelector";
import styles from "../styles/content.module.css";
import GettingStarted from "./GettingStarted";
import { DayOfWeekSelector } from "./MenuItemsGridList/DayOfWeekSelector";
import { FiltrableMenuItemBank } from "./MenuItemsGridList/FilterableMenuItemBank";
import { MenuMessageBar } from "./MenuPreview/MenuMessageBar";
import MenuPreview from "./MenuPreview/MenuPreview";
import StationSelector from "./StationSelector/StationSelector";
import { UpdateStation } from "./UpdateStation";

export default () => {
  const selectedCafe = useSelector(cafeSelector);
  const weekStart = useSelector(weekStartSelector);
  const calendarRef = useRef<IDatePicker>(null);
  const selectedStation = useSelector(stationSelector);
  const _layerHostId = getId("layerHost");
  const dispatch = useDispatch();

  return (
    <Stack
      horizontal={true}
      verticalFill={true}
      role="main"
      tokens={{ childrenGap: 20 }}
      className={styles.menuManagementSection}
    >
      <Stack.Item className={classNames("ms-depth-4", styles.stationSelector)} verticalFill={true} grow={false}>
        <StationSelector />
      </Stack.Item>

      {!selectedCafe ? (
        <GettingStarted />
      ) : (
        <Stack
          className={styles.horizontalContentStack}
          horizontal={true}
          wrap={true}
          tokens={{ childrenGap: 20 }}
          disableShrink={true}
        >
          <Stack tokens={{ childrenGap: 15 }} className={styles.itemBankSection}>
            <DatePicker
              className={styles.datePickerStyle}
              label="Menu for the week of:"
              minDate={dayjs().startOf("week").toDate()}
              value={dayjs(weekStart).toDate()}
              showGoToToday={true}
              placeholder="Select a date..."
              ariaLabel="Select a date"
              showMonthPickerAsOverlay={true}
              firstWeekOfYear={1}
              allowTextInput={true}
              componentRef={calendarRef}
              onSelectDate={(date) => date && dispatch(setStartOfWeek(dayjs(date).startOf("week").toDate()))}
            />
            <FiltrableMenuItemBank />
            <DayOfWeekSelector />
            {selectedStation && <UpdateStation />}
          </Stack>
          <Stack className={styles.menuPreviewSection}>
            <MenuMessageBar />
            <MenuPreview />
          </Stack>
        </Stack>
      )}

      <LayerHost id={_layerHostId}></LayerHost>
    </Stack>
  );
};
